import { BaseObject } from "./BaseObject";
import { Plan } from './Plan';
import { Subject } from './Subject';
import { SubjectCustomer } from "./SubjectCustomer";

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export class PlanOrganizacion extends BaseObject {

    id: number;
    /*
     * El precio personalizado para la organización
     */
    precio: number = 0;

    /**
     * Número máximo de comprobantes del plan para la organización
     */
    maximoComprobantes: number = 0;

    /**
     * Número de comprobantes del plan para la organización emitidos
     */
    numeroComprobantesEmitidos: number = 0;

    /**
     * Número mínimo de comprobantes antes de emitir alerta de recarga
     */
    minimoComprobantesAlertarRecarga: number = 0;

    /**
     * La organización del plan
     */
    organizacionId: number;

    /**
     * El plan para la organización
     */
    planId: number;

    /**
    * Si el plan está vigente vigente
    */
    vigente: boolean;

    /**
    * Si el plan esta pagado
    */
    pagado: boolean;

    /**
     * Fecha de inicio del plan
     */
    fechaInicio: Date;

    /**
     * Fecha de fin del plan
     */
    fechaFin: Date;

    /**
    * Acepta términos
    */
    aceptaTerminosCondiciones: boolean = false;

    /**
    * El plan para la organización de tipo firma
    */
    planIdTipoFirma: number;

    /**
     * El precio del plan tipo firma
     */
    planTipoFirmaPrecio: number;

    /**
     * Fecha de inicio del plan tipo firma
     */
    planTipoFirmaFechaInicio: Date;

    /**
     * Fecha de fin del plan tipo firma
     */
    planTipoFirmaFechaFin: Date;
    
    /**
    * El plan para la organización de tipo firma
    */
    planAgendamientoId: number;

    /**
     * El precio del plan tipo firma
     */
    planAgendamientoPrecio: number;

    /**
     * Fecha de inicio del plan tipo firma
     */
    planAgendamientoFechaInicio: Date;

    /**
     * Fecha de fin del plan tipo firma
     */
    planAgendamientoFechaFin: Date;

    /**
     * UX
     */
    planName: string;
    plan: Plan;
    organizacionName: string;
    organizacionMobileNumber: string;
    organizacionEmail: string;
    subject: Subject;
    subjectCustomer: SubjectCustomer;
    detallePago: string;
    planTipoFirmaName: string;
    planAgendamientoName: string;
    planTipoFirma: Plan;
    planAgendamiento: Plan;

    /*
    * Código de la persona que activa el plan
    */
    codigoPersonaActivaPlan: string;

} 